module.exports = __webpack_public_path__ + "static/media/cupcakeRedVelvet.621519d9.jpg";